import apolloClient from '@custom/core/apollo/apolloClient';
import api from '@custom/core/apollo/config/apiConfig';

import getArticleByIdQuery from '@custom/core/apollo/graphql/getArticles.graphql';

import { GetArticles } from '@custom/core/apollo/types/getArticles';

const getArticles = async (variables: GetArticles['variables']) => {
  const queryOptions = { variables };
  const options = <any>Object.assign({ query: getArticleByIdQuery }, queryOptions);

  const client = apolloClient(api.content_url, true);
  const { data } = await client.query<GetArticles['data']>(options);

  return data;
};

export default getArticles;
